<input
  #inputEl
  type="file"
  multiple="false"
  [accept]="allowedFilesExtStr"
  [hidden]="true"
  (change)="onChange($event)"
/>

<div class="content">
  <label>{{
    this.translationService.getCurrentLanguage()["drop-or-browse"]
  }}</label>

  <app-button
    class="btn-search"
    buttonType="primary"
    styleType="outlined"
    sizeType="small"
    [text]="this.translationService.getCurrentLanguage().search"
    (click)="onBtnSearchClick($event)"
    width="15rem"
  ></app-button>
</div>

<ng-container *ngIf="!!info">
  <div #infoEl class="info">
    <app-iconic
      class="info-icon"
      icon="assets/icons/circle-question.svg"
    ></app-iconic>
  </div>

  <app-tooltip
    [target]="infoEl"
    verticalAlignment="top"
    horizontalAlignment="center"
  >
    {{ info }}
  </app-tooltip>
</ng-container>
